import { render, staticRenderFns } from "./aktarimlar.vue?vue&type=template&id=22d58528&"
import script from "./aktarimlar.vue?vue&type=script&lang=js&"
export * from "./aktarimlar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports